import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, } from 'react-bootstrap';
import ServiceOfferingCard from '../../serviceOfferingCard/ServiceOfferingCard';

class ServiceOfferingsDisplay extends React.Component {
  searchFilter(search, serviceOffering) {
    const transform = {
      trash: 'refuse',
    };

    let value;

    if (transform[search]) {
      value = transform[search];
    } else {
      value = search.trim();
    }

    value = value
      .replace(/ /g, '12345')
      .replace(/\W/g, '')
      .replace(/12345/g, ' ');

    const regex = new RegExp(`.*${value}.*`, 'i');

    if (
      regex.test(serviceOffering.serviceOfferingName)
      || regex.test(serviceOffering.info.location)
      || regex.test(serviceOffering.info.description)
      || regex.test(serviceOffering.info.id)
    ) {
      return true;
    }

    return false;
  }

  sendUtilityNavigationRequest(id) {
    const { sendNavigationRequest, } = this.props;

    sendNavigationRequest({
      key: id,
    });
  }

  render() {
    const { serviceOfferings, search, } = this.props;

    const filteredServiceOfferings = serviceOfferings
      .filter(serviceOffering => this.searchFilter(search, serviceOffering));

    return (
      <>
        {filteredServiceOfferings.map((serviceOffering, index) => {
          const {
            serviceOfferingName, info, url, _id,
          } = serviceOffering;

          const {
            id, location, description, tooltipDescription,
          } = info;
          const keyIndex = index;
          const nextIndex = index + 1;
          const nextNextIndex = index + 2;

          if (index % 3 === 0) {
            if (
              nextIndex < filteredServiceOfferings.length
              && nextNextIndex < filteredServiceOfferings.length
            ) {
              return (
                <Row className="mt-5" key={`Row${keyIndex}`}>
                  <Col key={_id} xs={4} sm={4} md={4} lg={4} xl={4}>
                    <ServiceOfferingCard
                      serviceOffering={serviceOfferingName}
                      location={location}
                      description={description}
                      site={url}
                      tooltipDescription={tooltipDescription}
                      onClick={() => this.sendUtilityNavigationRequest(id)}
                    />
                  </Col>
                  <Col
                    key={filteredServiceOfferings[nextIndex]._id}
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                  >
                    <ServiceOfferingCard
                      serviceOffering={filteredServiceOfferings[nextIndex].serviceOfferingName}
                      location={filteredServiceOfferings[nextIndex].info.location}
                      description={filteredServiceOfferings[nextIndex].info.description}
                      site={filteredServiceOfferings[nextIndex].url}
                      tooltipDescription={
                        filteredServiceOfferings[nextIndex].info.tooltipDescription
                      }
                      onClick={() => this.sendUtilityNavigationRequest(
                        filteredServiceOfferings[nextIndex].info.id
                      )}
                    />
                  </Col>
                  <Col
                    key={filteredServiceOfferings[nextNextIndex]._id}
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                  >
                    <ServiceOfferingCard
                      serviceOffering={filteredServiceOfferings[nextNextIndex].serviceOfferingName}
                      location={filteredServiceOfferings[nextNextIndex].info.location}
                      description={filteredServiceOfferings[nextNextIndex].info.description}
                      site={filteredServiceOfferings[nextNextIndex].url}
                      tooltipDescription={
                        filteredServiceOfferings[nextNextIndex].info.tooltipDescription
                      }
                      onClick={() => this.sendUtilityNavigationRequest(
                        filteredServiceOfferings[nextNextIndex].info.id
                      )}
                    />
                  </Col>
                </Row>
              );
            }
            if (
              nextIndex < filteredServiceOfferings.length
              && nextNextIndex === filteredServiceOfferings.length
            ) {
              return (
                <Row className="mt-5 justify-content-center" key={`Row${keyIndex}`}>
                  <Col key={_id} xs={4} sm={4} md={4} lg={4} xl={4}>
                    <ServiceOfferingCard
                      serviceOffering={serviceOfferingName}
                      location={location}
                      description={description}
                      site={url}
                      tooltipDescription={tooltipDescription}
                      onClick={() => this.sendUtilityNavigationRequest(id)}
                    />
                  </Col>
                  <Col
                    key={filteredServiceOfferings[nextIndex]._id}
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                  >
                    <ServiceOfferingCard
                      serviceOffering={filteredServiceOfferings[nextIndex].serviceOfferingName}
                      location={filteredServiceOfferings[nextIndex].info.location}
                      description={filteredServiceOfferings[nextIndex].info.description}
                      site={filteredServiceOfferings[nextIndex].url}
                      tooltipDescription={
                        filteredServiceOfferings[nextIndex].info.tooltipDescription
                      }
                      onClick={() => this.sendUtilityNavigationRequest(
                        filteredServiceOfferings[nextIndex].info.id
                      )}
                    />
                  </Col>
                </Row>
              );
            }
            return (
              <Row className="mt-5 justify-content-center" key={`Row${keyIndex}`}>
                <Col key={_id} xs={4} sm={4} md={4} lg={4} xl={4}>
                  <ServiceOfferingCard
                    serviceOffering={serviceOfferingName}
                    location={location}
                    description={description}
                    site={url}
                    tooltipDescription={tooltipDescription}
                    onClick={() => this.sendUtilityNavigationRequest(id)}
                  />
                </Col>
              </Row>
            );
          }
          return null;
        })}
      </>
    );
  }
}

ServiceOfferingsDisplay.defaultProps = {
  search: undefined,
};

ServiceOfferingsDisplay.propTypes = {
  serviceOfferings: PropTypes.instanceOf(Object).isRequired,
  search: PropTypes.string,
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
};

export default ServiceOfferingsDisplay;
